export default __webpack_public_path__ + "components/wind-icon/static/ENE@2x-548d27af60240763308017bedca9f60a.png";